import React from 'react';
import { SitrepSectionWizardProvider } from './SitrepSectionWizardContext';
import SitrepSectionWizardHeader from './SitrepSectionWizardHeader';
import SitrepSectionWizardContent from './SitrepSectionWizardContent';
import SitrepSectionWizardFooter from './SitrepSectionWizardFooter';

/**
 * Entry point for the Sitrep Section Wizard. Renders the provider and the three
 * main subcomponents
 */
interface Props {
  setIsEditingSitrepSections: (isEditing: boolean) => void;
}
const SitrepSectionWizard = ({ setIsEditingSitrepSections }: Props) => (
  <SitrepSectionWizardProvider
    setIsEditingSitrepSections={setIsEditingSitrepSections}
  >
    <div className="sidebar">
      <SitrepSectionWizardHeader
        setIsEditingSitrepSections={setIsEditingSitrepSections}
      />
      <SitrepSectionWizardContent />
      <SitrepSectionWizardFooter
        setIsEditingSitrepSections={setIsEditingSitrepSections}
      />
    </div>
  </SitrepSectionWizardProvider>
);

export default SitrepSectionWizard;
